// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"fef073e3","60":"88cb6fd3","132":"6fc36428","195":"f9cb9154","220":"a3492eb7","324":"f6a063d7","544":"da4a4a38","547":"7d399cdb","549":"222461b9","610":"c4a01a6b","631":"2f6e55fd","687":"f6534ac2","896":"7d399cdb","904":"7d399cdb","925":"a4ac0143"}[chunkId] + ".chunk.css";
};